import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';

// Translation for Pagination default values
export const TranslateResultsPerPage = (itemsPerPage: number) => {
  return {
    resultsText: useDsTranslateMessage({
      id: 'mcds.results_per_page.results',
      defaultMessage: `${itemsPerPage} results per page`,
      values: { itemsPerPage: itemsPerPage },
    }),
    ofText: useDsTranslateMessage({
      id: 'mcds.results_per_page.of',
      defaultMessage: ' of ',
    }),
  };
};
